module.exports = __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm@3-4350aedae667fb503d913636e00667bc.png";